import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from '@brunata-angular/util';
import {SelectBuildingTableComponent} from 'src/app/select-building/select-building-table/select-building-table.component';
import {systemInformationLink} from '@shared/route-utils';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {filter, map, Observable, startWith} from 'rxjs';
import {LoadComponent} from '@brunata-angular/ui';
import {Store} from '@ngrx/store';
import {selectBuilding} from 'src/app/state/selectors';

@Component({
    selector: 'app-select-building-page',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TranslatePipe,
        SelectBuildingTableComponent,
        RouterOutlet,
        LoadComponent,
    ],
    template: `@if (noActivatedChildren$ | async) {
            <div class="container-fluid mb-3">
                @if (status | async) {
                    <app-load />
                } @else {
                    <h3>{{ 'titles_chooseSystem' | translate: 'online' : 'systems' }}</h3>

                    <app-select-building-table (loadBuilding)="selectBuilding($event)" />
                }
            </div>
        }
        <router-outlet />`,
})
export class SelectBuildingPageComponent {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly router = inject(Router);
    private readonly store = inject(Store);

    readonly status = this.store
        .select(selectBuilding)
        .pipe(map(state => state.status === 'loading'));

    readonly noActivatedChildren$: Observable<boolean> = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(null),
        map(() => this.activatedRoute.children.length === 0),
    );

    selectBuilding(building: {buildingNo: string}): void {
        void this.router.navigate(systemInformationLink(building.buildingNo));
    }
}
